import './input.scss';
import { useState } from 'react';

export default function Input(props) {

    const [randomID ] = useState(Math.random().toString(36).slice(2));

    const noop = () => {}

    return (
        <div className={props.className}>
            <div className={ 'form-control-component ' + (props.isInvalid ? 'is-invalid':'') }>
                <input type={props.type || 'text'}  id={randomID} placeholder={props.placeholder || props.label } onKeyUp={props.onKeyUp ? props.onKeyUp: noop } onChange={props.onChange ? props.onChange: noop } value={props.value} />
                <label htmlFor={randomID} >{ props.label }</label>
            </div>
            {props.isInvalid &&
                <p className='text-error-default mt-1 text-[12px]'>{props.feedback}</p>
            }
        </div>
    );
}
